import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostProjektArtCommandServiceModule } from '..';
import { PostProjektArtCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostProjektArtCommandServiceModule
  ],
  declarations: [PostProjektArtCommandComponent],
  exports: [PostProjektArtCommandComponent],

})
export class PostProjektArtCommandComponentModule { }
